import usePersistentState from "@/utils/usePersistentState";

const LAST_DOC_ID_LS_KEY = "lastDocId";

export function useLastDocId() {
  const [lastDocId, setLastDocId] = usePersistentState<string | undefined>(
    LAST_DOC_ID_LS_KEY,
    undefined,
  );
  return { lastDocId, setLastDocId };
}

export function setLastDocIdForTeam(teamUid: string, docId: string) {
  localStorage.setItem(`${LAST_DOC_ID_LS_KEY}-for-team-${teamUid}`, docId);
}

export function getLastDocIdForTeam(teamUid: string): string {
  if (typeof window === "undefined" || !window.localStorage) {
    return "";
  }
  return localStorage.getItem(`${LAST_DOC_ID_LS_KEY}-for-team-${teamUid}`) || "";
}
